const TOAST_EVENT = "mit-toast";

const RenderToast = ({ type = "info", message = "" }) => {
  const value = String(message || "").trim();

  if (!value || typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(
    new CustomEvent(TOAST_EVENT, {
      detail: {
        type,
        message: value,
      },
    }),
  );
};

export default RenderToast;
